// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#loading-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
  display: block;
  z-index: 99999;
  pointer-events: none;
}

.loading-logo {
  position: absolute;
  left: calc(50% - 100px);
  top: calc(50% - 60px);
}

.loading {
  position: absolute;
  left: calc(50% - 27px);
  top: 50%;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 3px solid transparent;
}

.loading .effect-1,
.loading .effect-2 {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-left: 3px solid rgb(2, 69, 163);
  border-radius: 50%;
  box-sizing: border-box;
}

.loading .effect-1 {
  animation: rotate 1s ease infinite;
}

.loading .effect-2 {
  animation: rotateOpacity 1s ease infinite 0.1s;
}

.loading .effect-3 {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-left: 3px solid rgb(2, 69, 163);
  animation: rotateOpacity 1s ease infinite 0.2s;
  border-radius: 50%;
  box-sizing: border-box;
}

.loading .effects {
  transition: all 0.3s ease;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(1turn);
  }
}
@keyframes rotateOpacity {
  0% {
    transform: rotate(0deg);
    opacity: 0.1;
  }
  100% {
    transform: rotate(1turn);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app-dispatcher.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;AACJ;;AAEE;EACE,kBAAA;EACA,uBAAA;EACA,qBAAA;AACJ;;AAEE;EACE,kBAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,sBAAA;EACA,6BAAA;AACJ;;AAEE;;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,sCAAA;EACA,kBAAA;EAEA,sBAAA;AACJ;;AAEE;EACE,kCAAA;AACJ;;AAEE;EACE,8CAAA;AACJ;;AAEE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,sCAAA;EAEA,8CAAA;EACA,kBAAA;EAEA,sBAAA;AACJ;;AAEE;EACE,yBAAA;AACJ;;AAEE;EACE;IAEE,uBAAA;EACJ;EAEE;IAEE,wBAAA;EAAJ;AACF;AAGE;EACE;IAEE,uBAAA;IACA,YAAA;EADJ;EAIE;IAEE,wBAAA;IACA,UAAA;EAFJ;AACF","sourcesContent":["#loading-bg {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    display: block;\n    z-index: 99999;\n    pointer-events: none;\n  }\n\n  .loading-logo {\n    position: absolute;\n    left: calc(50% - 100px);\n    top: calc(50% - 60px);\n  }\n\n  .loading {\n    position: absolute;\n    left: calc(50% - 27px);\n    top: 50%;\n    width: 55px;\n    height: 55px;\n    border-radius: 50%;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    border: 3px solid transparent;\n  }\n\n  .loading .effect-1,\n  .loading .effect-2 {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border: 3px solid transparent;\n    border-left: 3px solid rgba(2, 69 , 163, 1);\n    border-radius: 50%;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n\n  .loading .effect-1 {\n    animation: rotate 1s ease infinite;\n  }\n\n  .loading .effect-2 {\n    animation: rotateOpacity 1s ease infinite 0.1s;\n  }\n\n  .loading .effect-3 {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border: 3px solid transparent;\n    border-left: 3px solid rgba(2, 69 , 163, 1);\n    -webkit-animation: rotateOpacity 1s ease infinite 0.2s;\n    animation: rotateOpacity 1s ease infinite 0.2s;\n    border-radius: 50%;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n\n  .loading .effects {\n    transition: all 0.3s ease;\n  }\n\n  @keyframes rotate {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n\n    100% {\n      -webkit-transform: rotate(1turn);\n      transform: rotate(1turn);\n    }\n  }\n\n  @keyframes rotateOpacity {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n      opacity: 0.1;\n    }\n\n    100% {\n      -webkit-transform: rotate(1turn);\n      transform: rotate(1turn);\n      opacity: 1;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
